import { z } from "zod";
import apiMaterialSchema from "./apiMaterialSchema";

const apiTextureMaterialSchema = apiMaterialSchema.extend({
    mainTextureUrl: z.string(),
    normalMapUrl: z.string().nullable(),
   
  });

export default apiTextureMaterialSchema;